import { humanFormat } from "@medoma/models/date-and-time";
import { useSelectedDate } from "@/Utils/useSelectedDate";
import { Heading } from "@medoma/components/Heading/Heading";
import styles from "./SelectedDateHeading.module.scss";

export function SelectedDateHeading() {
  const selectedDate = useSelectedDate();

  return (
    <Heading level="h2" className={styles.heading}>
      {humanFormat(selectedDate, { weekday: "long" })},{" "}
      {humanFormat(selectedDate, { month: "long", day: "numeric" })}
    </Heading>
  );
}
